import React, { Dispatch, SetStateAction, useEffect, useRef } from 'react'
import { Question } from '@domoscio/domoscio-ui'

type Props = {
  qtiContent: any
  event: any
  setScreen: Dispatch<SetStateAction<'tsr' | 'correction'>>
}

const CorrectionDisplay = ({ qtiContent, event, setScreen }: Props) => {
  const score = event?.payload?.result?.score?.scaled ?? 0

  // get correction screen height and set the height of the correctionDisplayContainer
  const correctionScreenRef = useRef<HTMLDivElement>(null)

  // set the height of the correctionDisplayContainer
  useEffect(() => {
    if (correctionScreenRef.current) {
      const correctionDisplayContainer = document.getElementById('correctionDisplayContainer')
      if (correctionDisplayContainer) {
        // set correction screen height to the height of the positioningResult if it's bigger than 600px
        if (correctionScreenRef.current.clientHeight > 600) {
          correctionDisplayContainer.style.minHeight = `${correctionScreenRef.current.clientHeight - 20}px`
        } else {
          // if the correction screen is smaller than 600px, set the height to 600px
          correctionDisplayContainer.style.minHeight = '600px'
        }
      }
    }
  }, [])

  return (
    <div className='correctionScreen'>
      <div className='header'>
        <Question.QuizHeader
          title={qtiContent.concept}
          isRuCase={true}
          onCancel={() => setScreen('tsr')}
          onClose={() => setScreen('tsr')}
        />
      </div>
      <div className='container' ref={correctionScreenRef}>
        <Question
          {...qtiContent}
          userInput={event.answer.value}
          correctionScore={score}
          isCorrectionMode={true}
        />
      </div>
    </div>
  )
}

export default CorrectionDisplay
